export var SDK_VERSION = '6.9.0';
//# sourceMappingURL=version.js.map